import { useDispatch, useSelector }
    from 'react-redux';

import { RootState }
    from '../../store/store';

import {
    setChannels,
    setMyChannels,
    setUsers,
    setSelectedUser,
    setPageSize,
} from '../../store/slices/realtime/realtimeSlice';

import RealtimeService
    from '../../services/realtime/realtimeService';

import useLoading from '../useLoading';
import useApiErrorHandler from '../useApiErrorHandler';
import { useCallback } from 'react';

export const useRealtime = () => {

    const dispatch = useDispatch();

    const { handle } =
        useApiErrorHandler();

    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    const realtime =
        useSelector(
            (state: RootState) =>
                state.realtime
        );

    const handlerGetChannels =
        async () => {

            try {

                showLoadingIndicator();

                const response =
                    await RealtimeService.getChannels();

                dispatch(
                    setChannels(response)
                );

            } catch (error) {

                handle(error);

            } finally {

                hideLoadingIndicator();
            }
        };

    const handlerGetMyChannels = useCallback(
        async () => {

            try {

                const response =
                    await RealtimeService.getMyChannels();

                    // console.log(response)

                dispatch(
                    setMyChannels(response)
                );

            } catch (error) {

                handle(error);
            }
        },
        [dispatch]
    );

    const handlerGetUsers =
        async (
            page = 0,
            size = 10,
            search?: string,
            role?: string
        ) => {

            try {

                showLoadingIndicator();

                const response =
                    await RealtimeService.getUsers(
                        page,
                        size,
                        search,
                        role
                    );

                dispatch(
                    setUsers(response)
                );

            } catch (error) {

                handle(error);

            } finally {

                hideLoadingIndicator();
            }
        };

    const handlerGetUserSubscriptions =
        async (userId: number) => {

            try {

                showLoadingIndicator();

                const response =
                    await RealtimeService
                        .getUserSubscriptions(userId);


                dispatch(
                    setSelectedUser(response)
                );

            } catch (error) {

                handle(error);

            } finally {

                hideLoadingIndicator();
            }
        };

    const handlerUpdateUserSubscriptions =
        async (
            userId: number,
            dto: any
        ) => {

            try {

                showLoadingIndicator();

                const response =
                    await RealtimeService
                        .updateUserSubscriptions(
                            userId,
                            dto
                        );

                dispatch(
                    setSelectedUser(response)
                );


            } catch (error) {

                handle(error);

            } finally {

                hideLoadingIndicator();
            }
        };


    const updatePageSize =
        (size: number) => {

            dispatch(setPageSize(size));
        };


    return {

        ...realtime,

        handlerGetChannels,
        handlerGetMyChannels,

        handlerGetUsers,

        updatePageSize,

        handlerGetUserSubscriptions,

        handlerUpdateUserSubscriptions,
    };
};